import * as browserHelpers from 'helpers/browser';
import * as koDataHelpers from 'helpers/koData';
import * as requestsHelpers from 'helpers/requests';
import * as settingsHelpers from 'helpers/settings';
import { StringHelpers } from 'helpers/string';

Math.trunc = Math.trunc || function (x) {
    if (isNaN(x)) {
        return NaN;
    }
    if (x > 0) {
        return Math.floor(x);
    }
    return Math.ceil(x);
};


if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (str) {
        return this.lastIndexOf(str, 0) === 0;
    };
}

if (!$.browser)
    $.browser = require('helpers/browser').browser;

var WCC = {
    koData: koDataHelpers.koData,
    Settings: settingsHelpers.settings,
    Enums: enums,
    Labels: labels,
    Messages: messages,
    ContentMessages: contentMessages,
    System: require('helpers/system').SystemHelpers,
    API: require('helpers/api').APIHelpers,
    Uploaders: require('helpers/fineUploaders').FineUploadersHelpers,
    currentUser: settingsHelpers.getSetting('CurrentUser'),    

    emptyFn: function () { },

    // Base function for proper inheritance
    extend: function () {
        // inline overrides function
        var overrideFunc = function (obj) {
            for (var prop in obj) {
                this[prop] = obj[prop];
            }
        };
        // constructor of simple Object class
        var baseObjConstr = Object.prototype.constructor;
        // create closure function
        return function (subBase, supPar, overrides) {
            // if function called with 2 paramters, superclass and object literal
            if (typeof supPar == 'object') {
                // change vars, because called with 2 params
                overrides = supPar;
                supPar = subBase;
                // if contructor won't overriden, call parent with all passed args
                subBase = (overrides.constructor != baseObjConstr) ? overrides.constructor : function () { supPar.apply(this, arguments); };
            }
            // create temp function and vars with prototypes
            var F = function () { }, subBaseProt, supParProt = supPar.prototype;
            // change temp functiion prototype
            F.prototype = supParProt;
            // create new incstance of prototype, this will solve problem of one prototype chain
            subBaseProt = subBase.prototype = new F();
            // take care of inheritance, reset constructor
            subBaseProt.constructor = subBase;
            // make link to parent contructor
            subBase.superclass = supParProt;
            // reset parent constructor, don't know for what
            if (supParProt.constructor == baseObjConstr) {
                supParProt.constructor = supPar;
            }
            // add override function
            subBase.override = function (obj) {
                WCC.override(subBase, obj);
            };
            // add override to prototype
            subBaseProt.override = overrideFunc;
            // copy properties
            WCC.override(subBase, overrides);
            // add extend function
            subBase.extend = function (obj) { WCC.extend(subBase, obj); };
            // return new class (constructor function)
            return subBase;
        };
    }(),

    /**
		 * Copies and replaces properties of one object with another
		 * @param {Object} baseclass
		 * @param {Object} object literal
		 * @method override
		 */
    override: function (origClass, overrides) {
        if (overrides) {
            var origProt = origClass.prototype;
            // copy all properties to prototype
            for (var method in overrides) {
                origProt[method] = overrides[method];
            }

            if (WCC.isIE && overrides.toString != origClass.toString) {
                origProt.toString = overrides.toString;
            }
        }
    },

    ajaxRequest: requestsHelpers.ajaxRequest,
    beginRequest: requestsHelpers.beginRequest,
    handleSuccessRequest: requestsHelpers.handleSuccessRequest,
    handleErrorRequest: requestsHelpers.handleErrorRequest,

    isIE: browserHelpers.isIE,
    isMobileIE: browserHelpers.isMobileIE,
    isOldIE: browserHelpers.isOldIE,
    isIE8: browserHelpers.isIE8,

    getSetting: settingsHelpers.getSetting,
    setSetting: settingsHelpers.setSetting,

    getKOData: function (key, defaultValue) {
        if (WCC.koData && typeof WCC.koData[key] != "undefined") {
            return WCC.koData[key];
        } else {
            return defaultValue;
        }
    },

    emptyGuid: settings.emptyGuid,

    isNullOrEmpty: StringHelpers.isNullOrEmpty,
    cleanString: StringHelpers.cleanString,
    trimLeft: StringHelpers.trimLeft,
    isNotNullOrEmpty: StringHelpers.isNotNullOrEmpty,
    isEmailAddress: system.isEmailAddress,
    toFirstCharUpperString: StringHelpers.toFirstCharUpperString,
    toFirstCharLowerString: StringHelpers.toFirstCharLowerString,

    isMobile: function() {
        var check = false;

        (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera);

        return check;
    },

    escapeStringForRegEx: function (input) {
        return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
    },


    Reactor: (function () {
        function Event(name) {
            this.name = name;
            this.callbacks = [];
        }
        
        Event.prototype.registerCallback = function (callback) {
            this.callbacks.push(callback);
        };

        function Reactor() {
            this.events = {};
            this.groups = {};
        }

        Reactor.prototype.registerEvent = function (eventName, groupName) {
            if (groupName) {
                if (!this.groups[groupName].events[eventName]) {
                    var event = new Event(eventName);
                    this.groups[groupName].events[eventName] = event;
                }
            }
            else {
                if (!this.events[eventName]) {
                    var event = new Event(eventName);
                    this.events[eventName] = event;
                }
            }
        };

        Reactor.prototype.dispatchEvent = function (eventName, eventArgs) {
            if (this.events[eventName] && this.events[eventName].callbacks) {
                this.events[eventName].callbacks.forEach(function (callback) {
                    callback(eventArgs);
                });
            }
            $.each(this.groups, function (i, group) {
                if (group.events[eventName] && group.events[eventName].callbacks) {
                    group.events[eventName].callbacks.forEach(function (callback) {
                        callback(eventArgs);
                    });
                }
            });
        };

        Reactor.prototype.on = function (_eventName, callback, unbindPrevious, groupName) {
            const self = this,
                eventsNames = Array.isArray(_eventName) ? _eventName : [_eventName];
            if (unbindPrevious) {
                self.unbindEvent(_eventName, groupName);
            }
            $.each(eventsNames, function (i, eventName) {
                if (groupName) {
                    if (!self.groups[groupName]) {
                        self.groups[groupName] = { events: {} };
                    }
                    self.registerEvent(eventName, groupName);
                    self.groups[groupName].events[eventName].registerCallback(callback);
                }
                else {
                    self.registerEvent(eventName);
                    self.events[eventName].registerCallback(callback);
                }
            });
        };

        Reactor.prototype.off = function (eventName, callback) {
            const self = this,
                eventsNames = _(eventName).isArray() ? eventName : [eventName];

            _(eventsNames).each((eventName) => {
                if (self.events[eventName]) {
                    if(callback) {
                        // we have a callback to remove. remove that callback only
                        const idx = self.events[eventName].callbacks.indexOf(callback);

                        if (idx !== -1) {
                            self.events[eventName].callbacks.splice(idx, 1);

                            if (self.events[eventName].callbacks.length === 0) {
                                self.events[eventName] = undefined;
                            }
                        }
                    }
                    else {
                        // no callback provided. remove all callbacks
                        self.events[eventName].callbacks = [];
                        self.events[eventName] = undefined;
                    }
                }
            });
        };
        
        Reactor.prototype.unbindEvent = function (_eventName, groupName) {
            const self = this,
                eventsNames = Array.isArray(_eventName) ? _eventName : [_eventName];
            $.each(eventsNames, function (i, eventName) {
                if (groupName) {
                    if (self.groups[groupName] && self.groups[groupName].events[eventName]) {
                        delete self.groups[groupName].events[eventName];
                    }
                }
                else {
                    if (self.events[eventName]) {
                        delete self.events[eventName];
                    }
                }
            });
        };

        return new Reactor();
    })()
};


///////////////////////////////////////
///                                 ///
///           Other stuff           ///
///                                 ///
///////////////////////////////////////

// Namespace for all functions that can be added at run-time by any scripts or hooks
WCC.TempFuncions = {};

// jQuery shim for placeholder support for non compliant browsers
// https://github.com/parndt/jquery-html5-placeholder-shim
(function ($) {
    $.extend($, {
        placeholder: {
            browser_supported: function () {
                return this._supported !== undefined ?
                    this._supported :
                    (this._supported = !!('placeholder' in $('<input type="text">')[0]));
            },
            shim: function (opts) {
                var config = {
                    color: '#888',
                    cls: 'placeholder',
                    selector: 'input[placeholder], textarea[placeholder]'
                };
                $.extend(config, opts);
                return !this.browser_supported() && $(config.selector)._placeholder_shim(config);
            }
        }
    });

    $.extend($.fn, {
        _placeholder_shim: function (config) {
            function calcPositionCss(target) {
                var op = $(target).offsetParent().offset();
                var ot = $(target).offset();

                return {
                    top: ot.top - op.top,
                    left: ot.left - op.left,
                    width: $(target).width()
                };
            }
            function adjustToResizing(label) {
                var $target = label.data('target');
                if (typeof $target !== "undefined") {
                    label.css(calcPositionCss($target));
                    $(window).one("resize", function () { adjustToResizing(label); });
                }
            }
            return this.each(function () {
                var $this = $(this);

                if ($this.is(':visible')) {

                    if ($this.data('placeholder')) {
                        var $ol = $this.data('placeholder');
                        $ol.css(calcPositionCss($this));
                        return true;
                    }

                    var possible_line_height = {};
                    if (!$this.is('textarea') && $this.css('height') != 'auto') {
                        possible_line_height = { lineHeight: $this.css('height'), whiteSpace: 'nowrap' };
                    }

                    var ol = $('<label />')
                        .text($this.attr('placeholder'))
                        .addClass(config.cls)
                        .css($.extend({
                            position: 'absolute',
                            display: 'inline',
                            float: 'none',
                            overflow: 'hidden',
                            textAlign: 'left',
                            color: config.color,
                            cursor: 'text',
                            paddingTop: $this.css('padding-top'),
                            paddingRight: $this.css('padding-right'),
                            paddingBottom: $this.css('padding-bottom'),
                            paddingLeft: $this.css('padding-left'),
                            fontSize: $this.css('font-size'),
                            fontFamily: $this.css('font-family'),
                            fontStyle: $this.css('font-style'),
                            fontWeight: $this.css('font-weight'),
                            textTransform: $this.css('text-transform'),
                            backgroundColor: 'transparent',
                            zIndex: 99
                        }, possible_line_height))
                        .css(calcPositionCss(this))
                        .attr('for', this.id)
                        .data('target', $this)
                        .click(function () {
                            $(this).data('target').focus();
                        })
                        .insertBefore(this);
                    $this
                        .data('placeholder', ol)
                        .focus(function () {
                            ol.hide();
                        }).blur(function () {
                            ol[$this.val().length ? 'hide' : 'show']();
                        }).triggerHandler('blur');
                    $(window).one("resize", function () { adjustToResizing(ol); });
                }
            });
        }
    });
})(jQuery);

//jquery extensions
(function ($, undefined) {
    //extension to get cursor position for textfield
    $.fn.getCursorPosition = function () {
        var el = $(this).get(0);
        var pos = 0;
        if ('selectionStart' in el) {
            pos = el.selectionStart;
        } else if ('selection' in document) {
            el.focus();
            var Sel = document.selection.createRange();
            var SelLength = document.selection.createRange().text.length;
            Sel.moveStart('character', -el.value.length);
            pos = Sel.text.length - SelLength;
        }
        return pos;
    };
    //extension to insert text at the current cursor position
    $.fn.insertTextAtCurrentPosition = function (text) {
        var ctrl = $(this),
            currPos = ctrl.getCursorPosition(),
            len = ctrl.val().length;

        if (currPos == len)
            ctrl.val(ctrl.val() + text);
        else {
            if (currPos >= 0 && currPos < len) {
                var left = ctrl.val().substr(0, currPos),
                    right = ctrl.val().substr(currPos, len - currPos);

                ctrl.val(left + text + right);
            }
        }
    };
})(jQuery);

jQuery(document).add(window).bind('ready load', function () {
    if (jQuery.placeholder) {
        jQuery.placeholder.shim();
    }
});

export { WCC }